export default __webpack_public_path__ + "static/media/line.3cbcbd20.svg";